import React from 'react'
import { Container } from './styles'

const FormItemWrapper = ({ children }) => <Container>{children}</Container>

export default FormItemWrapper
